import { IFocusState } from '../../types/interfaces/states';
import { RootState } from '../store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: IFocusState = {
  focus: -1,
  stack: [],
};

const focusSlice = createSlice({
  name: 'focus',
  initialState,
  reducers: {
    clearFocus: (state) => {
      state.focus = -1;
      state.stack = [];
    },
    clearStack: (
      state,
      action: PayloadAction<number | (number | string)[] | undefined>
    ) => {
      state.stack = [];
      if (action.payload) {
        state.stack.push(action.payload);
      }
    },
    filterFocus: (
      state,
      action: PayloadAction<number | number[] | (number | string)[]>
    ) => {
      state.stack = state.stack.filter((focus) => focus !== action.payload);
    },
    popFocus: (state) => {
      const focus = state.stack.pop() ?? state.focus;
      state.focus = focus;
    },
    pushFocus: (state, action: PayloadAction<number | (number | string)[]>) => {
      if (
        state.focus !== -1 &&
        ((state.focus as number) >= 0 || (state.focus as number[]).length)
      ) {
        state.stack.push(state.focus);
      }
      state.focus = action.payload;
    },
    setFocus: (
      state,
      action: PayloadAction<number | number[] | (number | string)[]>
    ) => {
      state.focus = action.payload;
      state.stack = [];
    },
    setStack: (
      state,
      action: PayloadAction<(number | (string | number)[] | number[] | null)[]>
    ) => {
      state.stack = [...action.payload];
    },
    stackFocus: (
      state,
      action: PayloadAction<number | (number | string)[]>
    ) => {
      state.stack.push(action.payload);
    },
  },
});

const { actions, reducer: focusReducer } = focusSlice;
export const {
  clearFocus,
  clearStack,
  filterFocus,
  popFocus,
  pushFocus,
  setFocus,
  setStack,
  stackFocus,
} = actions;
export const focusSelector = (state: RootState) => state.focus;
export default focusReducer;
